{
	"app_fallbacks": {
		"error": {
			"description": "An unexpected error occurred while rendering this page. You can try again, or head back to a working area of the app.",
			"title": "Something went wrong."
		},
		"go_back": "Go back",
		"go_home": "Go home",
		"loading": "Loading",
		"not_found": {
			"description": "The page you're looking for doesn't exist or may have moved. Head back to a working area of the app.",
			"title": "Page not found."
		},
		"permission_error": {
			"description": "You don't have the permissions to access this page.",
			"title": "Access denied"
		},
		"try_again": "Try again"
	},
	"app_sidebar": {
		"menu": {
			"logout": "Log out",
			"profile": "Settings"
		},
		"user_menu": {
			"open": "Open user menu"
		}
	},
	"cancel": "Cancel",
	"change_password": "Change password",
	"created_at": "Created at",
	"current_password": "Current password",
	"delete_account": "Delete account",
	"edit": "Edit",
	"email": "Email",
	"name": "Name",
	"new_password": "New password",
	"password": "Password",
	"password_min": "Password must be at least 8 characters.",
	"save": "Save"
}
